var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('tiptap-vuetify',_vm._g(_vm._b({attrs:{"extensions":_vm.extensions}},'tiptap-vuetify',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }